<template>
    <div class="project">
        <el-menu theme="dark" :default-active="$route.path" class="el-menu-demo" mode="horizontal" router>
            <el-menu-item index="/home/subscribeCode/subscribeCode_Li">注册码记录</el-menu-item>
            <el-menu-item index="/home/subscribeCode/createCode">生成注册码</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>
  export default {
    name: 'project',
    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// subscribeCodeMenu.vue?3870ae37